module.exports = __webpack_public_path__ + "static/media/in.286a3316.png";